import React from 'react';

import {Logger} from '~/src/utilities/helpers/log';

const withErrorBoundary = (WrappedComponent, name) =>
    class extends React.Component {
        static getDerivedStateFromError(error) {
            return {error};
        }

        state = {};

        componentDidCatch(error, info) {
            Logger.error(
                error.name
                    ? `[${error.name}][${name || WrappedComponent.name}] Unhandled error`
                    : `[${name || WrappedComponent.name}] Unhandled error: ${error}`,
                {error, info}
            );
        }

        render() {
            return !this.state.error ? <WrappedComponent {...this.props} /> : null;
        }
    };

export {withErrorBoundary};
